(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/legacy-hbs-helpers.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/legacy-hbs-helpers.js');

'use strict';

const {
  svsuid,
  getFileFormat
} = svs.utils;
const cmsImagePrefix = '/cms/images';

const getUrlWithCorrectHost = (url, config) => {
  if (!url) {
    return '';
  }
  return url.startsWith('http') ? url : "".concat(config.options.cdn2).concat(url);
};

const getWithFilledPlaceholders = (url, width, extension) => {
  url = url.replace('{width}', width);
  url = url.replace('{extension}', extension);
  return url;
};

const getUrl = (image, extension, width) => {
  var _extension;
  let url;
  url = (image === null || image === void 0 ? void 0 : image.url.replace(/-({width}|%7Bwidth%7D)/g, "-".concat(width))) || '';
  url = getWithFilledPlaceholders(url, width, extension);
  if (image !== null && image !== void 0 && image.isPreview && !extension) {
    return url;
  }
  extension = (_extension = extension) === null || _extension === void 0 ? void 0 : _extension.replace(/\./g, '');
  return url;
};

const getDescriptor = (width, image) => {
  var _image$aspectRatio;
  width = width === 'original' ? (_image$aspectRatio = image.aspectRatio) === null || _image$aspectRatio === void 0 ? void 0 : _image$aspectRatio.width : width;
  return isNaN(width) ? '' : " ".concat(width, "w");
};

const getWithReplacedExtension = (url, extension) => {
  if (!url || typeof url !== 'string' || !extension || typeof extension !== 'string') {
    throw new Error('Invalid input. Both URL and extension must be non-empty strings.');
  }

  const newURL = url.replace(/\.\w+$/, ".".concat(extension.replace(/^\.*/, '')));
  return newURL;
};

const getSrcsetString = (image, extension, width, config) => {
  var _image$availableForma;
  let output;
  const extensionString = typeof extension === 'string' && extension || ((_image$availableForma = image.availableFormats) === null || _image$availableForma === void 0 || (_image$availableForma = _image$availableForma[0]) === null || _image$availableForma === void 0 ? void 0 : _image$availableForma.extension) || 'webp';

  output = getUrl(image, extensionString, width);

  output = getUrlWithCorrectHost(output, config);

  output = output.startsWith(cmsImagePrefix) ? getWithReplacedExtension(output, extensionString) : output;

  output = "".concat(output).concat(getDescriptor(width, image));
  return output;
};

const getSrcset = (image, extension, hbs, config) => {
  var _image$availableWidth;
  const srcsetArray = (image === null || image === void 0 || (_image$availableWidth = image.availableWidths) === null || _image$availableWidth === void 0 ? void 0 : _image$availableWidth.map(width => getSrcsetString(image, extension, width, config))) || ['noAvailableWidths'];
  return new hbs.SafeString(srcsetArray.toString());
};

const getNoscriptUrl = (image, images, noscriptUrl, isMultiImage, config) => {
  const getWidestItem = items => (items === null || items === void 0 ? void 0 : items.reduce((prev, curr) => (prev === null || prev === void 0 ? void 0 : prev.width) > (curr === null || curr === void 0 ? void 0 : curr.width) ? prev : curr, {
    width: 0
  })) || null;
  const $noscriptUrl = isMultiImage ? noscriptUrl : image === null || image === void 0 ? void 0 : image.noscriptUrl;

  const getMultiImageFallback = () => getWidestItem(images && Object.values(images));
  const getFallbackUrl = () => {
    var _fallbackImage$availa;
    const fallbackImage = isMultiImage ? getMultiImageFallback() : image;
    const highestWidth = Math.max(...((fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.availableWidths) || [0]));
    const extension = fallbackImage === null || fallbackImage === void 0 || (_fallbackImage$availa = fallbackImage.availableFormats) === null || _fallbackImage$availa === void 0 || (_fallbackImage$availa = _fallbackImage$availa[0]) === null || _fallbackImage$availa === void 0 ? void 0 : _fallbackImage$availa.extension;
    return getUrl(fallbackImage, extension, highestWidth);
  };
  const url = $noscriptUrl || getFallbackUrl();
  return getUrlWithCorrectHost(url, config);
};
const getSourceElementsData = (image, hbs, config) => {
  const {
    availableFormats,
    loadingLazy,
    media,
    sizes: imageSizes,
    url
  } = image;
  const formats = availableFormats !== null && availableFormats !== void 0 && availableFormats.length ? availableFormats : [getFileFormat('webp'), getFileFormat(url)];
  const sourcesData = formats === null || formats === void 0 ? void 0 : formats.map(_ref => {
    let {
      extension,
      mimetype
    } = _ref;
    const id = svsuid();
    const dataSrc = loadingLazy ? getSrcset(image, extension, hbs, config) : null;
    const srcSet = !loadingLazy ? getSrcset(image, extension, hbs, config) : null;
    const type = mimetype;
    const sizesFallback = '(min-width: 1020px) 100vw';
    const sizes = imageSizes || sizesFallback;
    return {
      id,
      dataSrc,
      media,
      sizes,
      srcSet,
      type
    };
  });
  return sourcesData;
};
const legacyHelpers = {
  getSrcset,
  getNoscriptUrl,
  getSourceElementsData
};
if (typeof exports === 'object') {
  module.exports = legacyHelpers;
} else {
  svs.content.image_v2.helpers.legacyHelpers = legacyHelpers;
}

 })(window);